module.exports = __webpack_public_path__ + "img/success.b4574253.png";